import { config } from './config';

// eslint-disable-next-line no-unused-vars
export function getBaseUrl(env) {
  return config.BASE_URL;
}